import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@app/core/guards/auth-guard.service';
import { LoginGuardService } from '@app/core/guards/login-guard.service';
import { ScanComponent } from './ui/scan/scan.component';
import { MaintenanceComponent } from './ui/maintenance/maintenance.component';
import { TermsOfServiceValidationComponent } from './ui/dashboard/terms-of-service-validation-component/terms-of-service-validation.component';

const routes: Routes = [
  
  {
    path: 'terms-of-service/validate/:guid',
    component: TermsOfServiceValidationComponent,
  },
  {
    path: 'dashboard',
    loadChildren: () => import('@app/ui/dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'login',
    loadChildren: () => import('@app/ui/login/login.module').then(m => m.LoginModule),
    canActivate: [LoginGuardService],
  },
  {
    path: 'context',
    loadChildren: () => import('@app/ui/context/context.module').then(m => m.ContextModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'offers',
    loadChildren: () => import('@app/ui/offer/offer.module').then(m => m.OfferModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'product',
    loadChildren: () => import('@app/ui/product/product.module').then(m => m.ProductModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'user',
    loadChildren: () => import('@app/ui/user/user.module').then(m => m.UserModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'order-in-progress',
    loadChildren: () => import('@app/ui/order/order.module').then(m => m.OrderModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'scan',
    children: [{ path: '', component: ScanComponent }],
    canActivate: [AuthGuardService],
    // component: ScanComponent,
  },
  {
    path: 'online-payment',
    loadChildren: () => import('@app/ui/online-payment/online-payment.module').then(m => m.OnlinePaymentModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'reclamation',
    loadChildren: () => import('@app/ui/user/reclamation/reclamation.module').then(m => m.ReclamationModule),
    canActivate: [AuthGuardService],
  },
  {
    path: '',
    pathMatch: 'full',
    //canActivate: [AuthGuardService],
    redirectTo: '/context',
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,

}),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
